import React from 'react';
import { motion } from 'framer-motion';
import '../styles/ServicesSection.css';
import { useNavigate } from 'react-router-dom';

const ServicesSection = () => {
    const navigate = useNavigate();

    const services = [
      {
        name: 'Passport/Visa',
        description: 'Get assistance with your visa and passport needs for a smooth travel experience.',
        image: '/Assets/image/passport.jpg',
        link: '/services/passport-visa',
      },
      {
        name: 'Flight Booking',
        description: 'Book flights at the best rates and enjoy a hassle-free journey.',
        image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
        link: '/services/flight-booking',
      },
      {
        name: 'Tour Packages',
        description: 'Explore our curated tour packages for unforgettable travel experiences.',
        image: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
        link: '/services/tour-packages',
      },
      {
        name: 'Cruise',
        description: 'Enjoy luxury cruises with breathtaking views and world-class amenities.',
        image: 'https://images.unsplash.com/photo-1548574505-5e239809ee19?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
        link: '/services/cruise',
      },
    ];

    return (
      <section className="se-services-section">
        <motion.h2
          className="se-services-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          Our Services
        </motion.h2>

        <motion.p
          className="se-services-description"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          Explore our travel services to make your journey memorable and seamless.
        </motion.p>

        <div className="se-services-container">
          {services.map((service, index) => (
            <motion.div
              className="se-service-card"
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.5,
                delay: 0.1 + index * 0.1,
                ease: "easeOut"
              }}
              whileHover={{
                translateY: -10,
                scale: 1.02,
                transition: { duration: 0.3 }
              }}
              viewport={{ once: true }}
              onClick={() => navigate(service.link)}
            >
              <div className="se-service-image-container">
                <img src={service.image} alt={service.name} className="se-service-image" />
              </div>
              <div className="se-service-content">
                <h3 className="se-service-name">{service.name}</h3>
                <p className="se-service-description">{service.description}</p>
                <button className="se-service-button">View Details</button>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    );
  };

  export default ServicesSection;